export const ACCOUNT_SEARCH_INPUT_ID = 'account-search-input';
export const ACCOUNT_SEARCH_SUBMIT_ID = 'account-search-submit';
export const ACCOUNT_SEARCH_RESULTS_TABLE_ID = 'account-search-results';
export const ACCOUNT_SEARCH_ITEM_CLASS = 'account-search-item';
